import { createContext, use } from "react";

export interface DrillDownScrollRequest {
  field: string;
  nonce: number;
}

export interface DrillDownGridScrollContextValue {
  /**
   * Field names (dimension names) currently rendered as columns in the open
   * drill-down grid. Reported by `DrillDownGridWrapper`; consumed by the title
   * to decide which source-column captions are clickable.
   */
  visibleColumnFields: string[];
  /** Called by the grid wrapper to publish its current column field names. */
  setVisibleColumnFields: (fields: string[]) => void;
  /**
   * The latest scroll-to-field request. `nonce` increments on every request so
   * repeated clicks on the same field re-fire the wrapper's effect.
   */
  scrollRequest: DrillDownScrollRequest | null;
  /** Request the grid to scroll to the column for `field`. */
  requestScrollToField: (field: string) => void;
}

const noop = () => {};

export const DrillDownGridScrollContext = createContext<DrillDownGridScrollContextValue>({
  visibleColumnFields: [],
  setVisibleColumnFields: noop,
  scrollRequest: null,
  requestScrollToField: noop,
});

export const useDrillDownGridScroll = () => use(DrillDownGridScrollContext);
